module.exports = __webpack_public_path__ + "img/B1_HQ.9938575f.jpg";